<template>
  <div id="app">
    <header>
      <div>
        <nav class="flex j-c-center relative">
          <!--Menu Mobile-->
          <div class="absolute menu-float-right show-mobile-992">
            <div class="text-center logoInFloar">
              <router-link :to="'/'">
                <img
                  class="img-responsive"
                  src="@/assets/logoBrancaHorizontal.png"
                  alt="logoBrancaHorizontal.png"
                  @click="closingMenu()"
                />
              </router-link>
            </div>
            <div class="absolute flex ul-fahter-mobile">
              <ul class="ul-mobile text-center">
                <li class="toUpperCase flex j-c-center">
                  <a
                    href="#"
                    @click="scrolA('#section_II', false) | closingMenu()"
                    >o que é?</a
                  >
                </li>
                <li class="toUpperCase flex j-c-center">
                  <a
                    href="#"
                    @click="scrolA('#section_VI', false) | closingMenu()"
                    >Nossos serviços</a
                  >
                </li>
                <li class="toUpperCase flex j-c-center">
                  <a
                    href="#"
                    @click="scrolA('#section_V', false) | closingMenu()"
                    >Nossas unidades</a
                  >
                </li>
                <li class="toUpperCase flex j-c-center">
                  <a
                    href="#"
                    @click="scrolA('#section_IV', false) | closingMenu()"
                    >Por que a Ponto Fácil?</a
                  >
                </li>
                <li
                  class="toUpperCase theDifentLiMobile f-w-700 flex j-c-center"
                  @click="closingMenu()"
                >
                  <!-- <router-link :to="'/seja-um-franqueado'" >seja um <br> franqueado</router-link> -->
                  <a href="//www.franquia.pontofacil.com.br/"
                    >seja um <br />
                    franqueado</a
                  >
                </li>
                <!--
                <li class="toUpperCase flex j-c-center" @click="closingMenu()">
                  <router-link :to="'/vagas'" >trabalhe <br> conosco</router-link>

                   
                </li>
                -->
              </ul>
            </div>
          </div>
          <!--Menu Desktop-->
          <ul class="ul-desktop">
            <li class="toUpperCase show-desktop-992">
              <a href="#" @click="scrolA('#section_II', false)">O que é?</a>
            </li>
            <li class="toUpperCase show-desktop-992">
              <a href="#" @click="scrolA('#section_VI', false)"
                >Nossos serviços</a
              >
            </li>
            <li class="toUpperCase show-desktop-992">
              <a href="#" @click="scrolA('#section_V', false)"
                >Nossas Unidades</a
              >
            </li>
            <li class="noPadding ">
              <a href="#" @click="scrolA('#section_I', false)">
                <img
                  class="img-responsive logo logochange"
                  :src="imgWhite"
                  alt="logoBrancaHorizontal.png"
                />
              </a>
            </li>
            <li class="toUpperCase show-desktop-992">
              <a href="#" @click="scrolA('#section_IV', false)"
                >Por que a Ponto Fácil?</a
              >
            </li>
            <li class="toUpperCase f-w-700 show-desktop-992">
              <!-- <router-link :to="'/seja-um-franqueado'">Seja um franqueado!</router-link> -->
              <a href="//franquia.pontofacil.com.br/"
                >Seja um franqueado!</a
              >
            </li>
            <li class="toUpperCase f-w-700 show-desktop-992 hidenCalculadora">
              <router-link :to="'/calculadora'" class="color-white a-work-with-us">Calculadora</router-link>
            </li>
          </ul>
          <div class="absolute show-mobile-992 icon-bars">
            <img
              class="img-responsive"
              src="@/assets/Icon-bars-white.png"
              alt="Icon-bars"
              id="iconBars"
              @click="openingMenu"
            />
            <img
              class="img-responsive"
              src="@/assets/close.png"
              alt="close.png"
              id="iconClose"
              @click="closingMenu"
            />
          </div>
        </nav>
      </div>
    </header>

    <transition name="slide-fade" mode="out-in">
      <router-view />
    </transition>

    <footer id="footer">
      <div>
        <VueSlickCarousel v-bind="settings">
          <div
            v-for="(item, index) in imgsToFooterCarousel"
            class="imgsGroup"
            :key="index"
            :style="{ 'background-image': 'url(' + item + ')' }"
          ></div>
        </VueSlickCarousel>
        <div class="container">
          <div class="row footer-content">
            <div class="col-md-8 mx-auto">
              <div class="row">
                <div class="col-md-6 col-12 flex j-c-center">
                  <img
                    class="logo-footer img-responsive"
                    src="@/assets/logoFooter.png"
                    alt="Logo Ponto Fácil"
                  />
                </div>
                <!-- <div class="col-md-6 flex j-c-center show-desktop-992"> -->
                <div class="col-md-6 flex j-c-center">
                  <div>
                    <div class="btn-be-franchisee bg-color-F38235">
                      <!-- <router-link :to="'/seja-um-franqueado'">Seja um franqueado</router-link> -->
                      <a href="//www.franquia.pontofacil.com.br/"
                        >Seja um franqueado!</a
                      >
                    </div>
                    <!--                  
                      <div class="flex j-c-center mt-4">
                        <router-link :to="'/vagas'" class="color-white a-work-with-us">Trabalhe Conosco</router-link>
                      </div>
                      -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center copyRight">
          <p>{{ year }} - Ponto Fácil © Todos os direitos reservados</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<style>
@import "./app.css?v=4";
.hidenCalculadora {
  display: none;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#iconClose {
  display: none;
}

.imgsGroup {
  overflow: hidden;
  height: 250px;
  background-size: cover;
  background-position: center;
  border: 2px solid #fff;
  border-top: 4px solid #fff;
  border-bottom: 4px solid #fff;
}

.imgsGroup img {
  width: 100% !important;
}

.a-work-with-us:hover {
  color: rgba(255, 255, 255, 0.75);
  text-decoration: underline;
}

nav {
  height: 80px;
}

.icon-bars {
  right: 30px;
}

.icon-bars img {
  width: 25px;
}

.icon-close img {
  width: 25px;
}

.icon-bars img:hover,
.icon-bars img:focus {
  cursor: pointer;
}
header {
  z-index: 999;
  position: fixed;
  width: 100vw;
}

header ul {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  padding: 0;
  position: fixed;
}

header ul li {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  vertical-align: middle;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 15px;
}

.logo {
  width: 130px;
  margin: 5px 15px;
}

header a {
  color: #fff;
}

header a:hover {
  text-decoration: none;
  color: #fff;
}

.noPadding {
  padding: 0;
}

nav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

footer {
  background-color: rgb(23, 93, 147);
}

footer p {
  margin: 0;
  font-size: 14px;
  color: #fff;
}

/* .btn-be-franchisee a{
  padding: 10px 25px;
  background-color: rgb(243, 130, 53);
  color: #fff;
  font-weight: 600;
  border-radius: 10px;
} */

.btn-be-franchisee a:hover {
  text-decoration: none;
}

footer .logo-footer {
  padding: 50px 0;
  width: 220px;
}

.footer-content {
  padding: 25px 0;
}

.copyRight {
  padding: 0 0 10px 0;
}

@media only screen and (max-width: 992px) {
  .copyRight p {
    font-size: 12px;
  }
  .menu-float-right {
    height: 100vh;
    width: 300px;
    right: -300px;
    top: 0;
    background-color: rgb(23, 93, 147);
    border: 1px solid rgba(0, 0, 0, 0.3);
  }

  .closingMenu {
    color: #357eb8;
    bottom: 0;
    font-size: 40px;
  }

  .ul-mobile {
    display: table-row;
  }

  .ul-mobile li {
    padding: 10px 10px;
  }

  .ul-mobile li a {
    color: #357eb8;
  }

  .logoInFloar {
    width: 100%;
  }

  .logoInFloar img {
    width: 100px;
    padding: 5px 15px 5px 0;
    margin-top: 20px;
  }

  .ul-mobile {
    position: relative;
    width: 350px;
  }

  .ul-fahter-mobile {
    margin-top: 100px;
  }

  .ul-mobile li {
    padding: 10px 10px 10px 0;
  }
  .ul-mobile li a {
    color: #fff !important;
  }

  .theDifentLiMobile a {
    padding: 25px 25px;
    margin: 20px 0;
    border-top: 1px solid #fff;
    border-bottom: 1px solid #fff;
  }
  @media only screen and (max-width: 767px) {
    .imgsGroup {
      height: 300px;
    }
  }
  @media only screen and (max-width: 330px) {
    header nav a {
      font-size: 14px;
    }
    .theDifentLiMobile a {
      margin: 10px;
    }
  }
}
</style>

<script>
import $ from "jquery";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  components: { VueSlickCarousel },

  data() {
    return {
      year: "",
      imgWhite: require("./assets/logoBrancaHorizontal.png"),
      imgBlue: require("./assets/logoAzulHorizontal.png"),
      iconBarsWhite: require("./assets/Icon-bars-white.png"),
      iconBarsBlue: require("./assets/Icon-bars-blue.png"),
      iconClose: require("./assets/close.png"),
      Bars: $("#iconBars"),
      Close: $("#iconClose"),
      boDy: $("body"),
      menu: $(".menu-float-right"),
      imgsToFooterCarousel: [
        require("./assets/home/carouselFooter/slide1.jpg"),
        require("./assets/home/carouselFooter/slide2.jpg"),
        require("./assets/home/carouselFooter/slide3.jpg"),
        require("./assets/home/carouselFooter/slide4.jpg"),
        require("./assets/home/carouselFooter/slide5.jpg"),
        require("./assets/home/carouselFooter/slide6.jpeg"),
        require("./assets/home/carouselFooter/slide7.jpg"),
      ],
      settings: {
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 5,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
            },
          },
        ],
      },
    };
  },
  created: function() {
    window.addEventListener("scroll", this.scrollWindow);
  },
  mounted() {
    this.year = new Date().getFullYear();
    this.closingMenu();
    this.year = new Date().getFullYear();
  },
  methods: {
    scrollWindow() {
      const nav = $("nav");
      if ($(window).scrollTop() >= 50) {
        $(nav).css({
          "background-color": "#fff",
          "-webkit-box-shadow": "0px 3px 13px -2px rgba(0,0,0,0.75)",
          "-moz-box-shadow": "0px 3px 13px -2px rgba(0,0,0,0.75)",
          " box-shadow": "0px 3px 13px -2px rgba(0,0,0,0.75)",
        });
        $(".ul-desktop li a").css({
          color: "#175D93",
        });
        $(".logochange").attr("src", this.imgBlue);
        $(".icon-bars img").attr("src", this.iconBarsBlue);
      } else {
        $("nav").css({
          "background-color": "transparent",
          "-webkit-box-shadow": "none",
          "-moz-box-shadow": "none",
          " box-shadow": "none",
        });
        $(".ul-desktop li a").css({
          color: "#fff",
        });
        $(".logochange").attr("src", this.imgWhite);
        $(".icon-bars img").attr("src", this.iconBarsWhite);
      }
    },
    // scrolA: function ($selector, stayInpage, diff1 = 250, diff2 = 150 ) {
    scrolA: function($selector, stayInpage) {
      /* eslint-disable no-console */
      let diff = 0;

      function scroll() {
        //   // var teste =  $($selector).offset();
        //   // console.log(teste);
        //   var diff = diff1;
        //   if($(window).width()<=767){
        //     diff == diff1;
        //   }else{
        //     diff == diff2;
        //   }
        if ($selector == "#section_V" && $(window).width() > 767) {
          diff = 200;
        } else {
          diff = 85;
        }

        $("html, body").animate(
          {
            scrollTop: $($selector).position().top - diff,
          },
          100
        );
      }

      if (this.$route.path == "/" || stayInpage) {
        scroll();
      } else {
        this.$router.push("/");
        setTimeout(scroll, 1000);
      }
    },
    closingMenu() {
      this.menu.css("right", "-300px");
      this.boDy.css("right", "0");
      $("#iconBars").css("display", "flex");
      $("#iconClose").css("display", "none");
    },
    openingMenu() {
      this.menu.css("right", "0");
      this.boDy.css("right", "275px");
      $("#iconBars").css("display", "none");
      $("#iconClose").css("display", "flex");
    },
  },
};
</script>
